const ROUTE_SYSTEM_MANAGE = [{
    path: 'system-manage/organizational-structure/add',
    meta: {
      name: "添加成员"
    }
  },
  {
    path: 'system-manage/companyInfo',
    meta: {
      name: "公司基本信息"
    }
  },
  {
    path: 'system-manage/dict/list',
    meta: {
      name: "数据字典管理"
    }
  },
  // {path: 'system-manage/OtherServiceAccounts', meta: { name: "第三方服务账号管理"}},
  {
    path: 'system-manage/other-service/list',
    meta: {
      name: "第三方服务账号管理重构版"
    }
  },
  {
    path: 'system-manage/functionalAuthority',
    meta: {
      name: "功能权限管理"
    }
  },
  {
    path: 'system-manage/other-authorization/index',
    meta: {
      name: "第三方授权管理"
    }
  },
  {
    path: 'system-manage/admin-authorization/index',
    meta: {
      name: "管理员管理"
    }
  },
  {
    path: 'system-manage/weeklyMailManage',
    meta: {
      name: "周报邮件管理"
    }
  },
  {
    path: 'system-manage/systemJournal/index',
    meta: {
      name: "系统日志"
    }
  },
  {
    path: 'system-manage/fullCalendar/index',
    meta: {
      name: "工作日配置"
    }
  },
]

export default ROUTE_SYSTEM_MANAGE



// WEBPACK FOOTER //
// ./src/router/mapping/system-manage.js